module.exports = __webpack_public_path__ + "static/img/shopimg.34c41cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopimg.png?v=1
// module id = XXGF
// module chunks = 1